import { createContext, useContext, useEffect, useState } from "react";
import { doc, getDoc, setDoc, updateDoc } from "firebase/firestore";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { db } from "../Admin/Config/Config";


const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, async (authUser) => {
      if (authUser) {
        const userRef = doc(db, "users", authUser.uid);
        const userSnap = await getDoc(userRef);

        if (!userSnap.exists()) {
          // Create a new user document
          const expiryDate = new Date();
          expiryDate.setDate(expiryDate.getDate() + 2);
         
          const orderRef = doc(db, "order", "order");
            const orderSnap = await getDoc(orderRef);
            if (orderSnap.exists()) {
                 const newUser = {
                   android_id:"",
                   uid: authUser.uid,
                   created: new Date(),
                   created_datestring: new Date().toDateString(),
                   date: expiryDate,
                   datestring: expiryDate.toDateString(),
                   mobile: "",
                   name: authUser.displayName || "Unnamed",
                   email: authUser.email || "",
                   photoURL: authUser.photoURL || "",
                   createdAt: new Date(),
                   payment: "trial",
                   study_stream: "Jaffers English",
                   order: (parseInt(orderSnap.data().order)+1).toString(),
                 };
                 await updateDoc(orderRef, {
                   order: (parseInt(orderSnap.data().order) + 1).toString(),
                 });
                await setDoc(userRef, newUser, { merge: true });
                setUser({ uid: authUser.uid, ...newUser });
                window.location.reload();
            }
        }

        setUser({ uid: authUser.uid, ...userSnap.data() });
      } else {
        setLoading(false);
        setUser(null);
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  return (
    <UserContext.Provider value={{ user, loading }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);
